var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.7_Acordes---mensagem-de-erro",
    transform: "translate(-688.000000, -28.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,28 C712.836556,28 720,35.163444 720,44 C720,52.836556 712.836556,60 704,60 C695.163444,60 688,52.836556 688,44 C688,35.163444 695.163444,28 704,28 Z M704,29.3 C695.881414,29.3 689.3,35.8814142 689.3,44 C689.3,52.1185858 695.881414,58.7 704,58.7 C712.118586,58.7 718.7,52.1185858 718.7,44 C718.7,35.8814142 712.118586,29.3 704,29.3 Z M711.071068,36.5789322 C711.324909,36.832773 711.324909,37.2443302 711.071068,37.498171 L704.919946,43.6492929 L711.071068,49.801829 C711.324909,50.0556698 711.324909,50.467227 711.071068,50.7210678 C710.817227,50.9749086 710.40567,50.9749086 710.151829,50.7210678 L704.000707,44.5685317 L697.848171,50.7210678 C697.59433,50.9749086 697.182773,50.9749086 696.928932,50.7210678 C696.675091,50.467227 696.675091,50.0556698 696.928932,49.801829 L703.081468,43.6492929 L696.928932,37.498171 C696.675091,37.2443302 696.675091,36.832773 696.928932,36.5789322 C697.182773,36.3250914 697.59433,36.3250914 697.848171,36.5789322 L704.000707,42.7300541 L710.151829,36.5789322 C710.40567,36.3250914 710.817227,36.3250914 711.071068,36.5789322 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close-dark.5cbd16d41edf0e61b9b62371ebc349af.svg";
export { ForwardRef as ReactComponent };